import React from "react";
import PropTypes from "prop-types";

import { UIChip } from "../../../../../ui";
import { getEventRoleColor } from "../../../../../../utils/eventRoleColors";

const EventPayrollBulkRatesLegendGroup = ({
  title,
  rates,
  ratePerDayLegend,
  variant,
}) => {
  if (rates.length === 0) return null;

  return (
    <div className="event-payroll-generate__rate-group">
      <UIChip
        shape="pill"
        size="small"
        color={variant === "training" ? "warning" : "primary"}
        className="event-payroll-generate__role-badge"
        label={title}
      />
      <ul className="event-payroll-generate__rate-list">
        {rates.map((role) => (
          <li key={role.id} className="event-payroll-generate__rate-item">
            <span
              className="event-payroll-generate__rate-dot"
              style={{ background: getEventRoleColor(role.name) }}
              aria-hidden="true"
            />
            <span className="event-payroll-generate__rate-text text-label-xs">
              {ratePerDayLegend
                .replace("{role}", role.name)
                .replace("{amount}", String(role.rate))}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

const EventPayrollBulkRatesLegend = ({
  roleRates,
  trainingRates,
  labels,
}) => (
  <div className="event-payroll-generate__rate-lists">
    <EventPayrollBulkRatesLegendGroup
      title={labels.rolesLegend}
      rates={roleRates}
      ratePerDayLegend={labels.ratePerDayLegend}
      variant="roles"
    />
    <EventPayrollBulkRatesLegendGroup
      title={labels.trainingsLegend}
      rates={trainingRates}
      ratePerDayLegend={labels.ratePerDayLegend}
      variant="training"
    />
  </div>
);

const rateShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  rate: PropTypes.number,
});

EventPayrollBulkRatesLegendGroup.propTypes = {
  title: PropTypes.string.isRequired,
  rates: PropTypes.arrayOf(rateShape).isRequired,
  ratePerDayLegend: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["roles", "training"]).isRequired,
};

EventPayrollBulkRatesLegend.propTypes = {
  roleRates: PropTypes.arrayOf(rateShape).isRequired,
  trainingRates: PropTypes.arrayOf(rateShape).isRequired,
  labels: PropTypes.shape({
    rolesLegend: PropTypes.string.isRequired,
    trainingsLegend: PropTypes.string.isRequired,
    ratePerDayLegend: PropTypes.string.isRequired,
  }).isRequired,
};

export default EventPayrollBulkRatesLegend;
